import type { TRuleWithTheme } from '@/styles/theme';

export const input: TRuleWithTheme = ({ theme }) => ({
    '&.ant-input-affix-wrapper': {
        height: '2.5rem',
        padding: '0.5rem 1rem',

        color: theme.colors.black,
        backgroundColor: theme.colors.inputsBackgroundPlaceholder,
        borderColor: theme.colors.bgGrey,
        outline: 'none',

        ':hover': {
            backgroundColor: theme.colors.white,
            boxShadow: 'none',
        },
        ':focus-within': {
            backgroundColor: theme.colors.white,
            boxShadow: 'none',
        },
        '& > input.ant-input::placeholder': {
            color: theme.colors.foregroundsTertiary,
        },
    },
});

export const clear: TRuleWithTheme = () => ({
    height: '1.5rem',
    padding: 0,
    background: 'none',
    border: 'none',
    cursor: 'pointer',
});
